// extracted by mini-css-extract-plugin
module.exports = {"tableHeader":"TableHeader_tableHeader__3LULB","tableHeaderRow":"TableHeader_tableHeaderRow__2Tn6A","tableHeaderCell":"TableHeader_tableHeaderCell__3GQiM"};